import test from "./test.js";

function baseUrl() {
  return "https://h5-bob.qjjtech.com/loan";
  // https://h5-bob.qjjtech.com/loan
  // return "http://101.42.164.51:8084";
  // return "http://192.168.1.15:8083";
}

// 检查是否存在token 否则就跳转到登录页面
function checkToken() {
  if (!uni.getStorageSync("v-token")) {
    uni.navigateTo({
      url: "/pages/account/login",
    });
  }
}

// 查重 并去除相同类
function unique(tempArr) {
  for (let i = 0; i < tempArr.length; i++) {
    for (let j = i + 1; j < tempArr.length; j++) {
      if (tempArr[i].fileKind == tempArr[j].fileKind) {
        tempArr.splice(j, 1);
        j--;
      }
    }
  }
  return tempArr;
}

//多层嵌套对象 控制不覆盖
function convertNullToEmpty(obj) {
  for (let key in obj) {
    if (typeof obj[key] === "object" && obj[key] !== null) {
      if (Array.isArray(obj[key])) {
        for (let i = 0; i < obj[key].length; i++) {
          if (obj[key][i] === null) {
            obj[key][i] = "";
          } else if (typeof obj[key][i] === "object") {
            convertNullToEmpty(obj[key][i]);
          }
        }
      } else {
        convertNullToEmpty(obj[key]);
      }
    } else if (obj[key] === null) {
      obj[key] = "";
    }
  }
}

// toast弹窗
function toast(title, icon, fn) {
  uni.showToast({
    icon: icon || "none",
    title: title,
    success() {
      fn && fn();
    },
  });
}

// 登录表格验证
function loginValidate(form) {
  if (test.isEmpty(form.phone)) {
    toast("请输入手机号", "");
    return;
  }
  if (!test.mobile(form.phone)) {
    toast("手机号码不正确", "");
    return;
  }
  if (test.isEmpty(form.code)) {
    toast("请输入验证码", "");
    return;
  }
  return true;
}
// 个人申请 法人信息补充表格验证
function submitForm(form) {
  console.log(form);
  // if(test.isEmpty(form.userName)){
  // 	toast('请输入姓名','')
  // 	return
  // }
  // if(test.isEmpty(form.certificateNo)){
  // 	toast('请输入身份证号','')
  // 	return
  // }
  // if(!test.mobile(form.sex)){
  // 	toast('请选择性别','')
  // 	return
  // }
  // if(test.isEmpty(form.mobileNo)){
  // 	toast('请输入手机号','')
  // 	return
  // }
  // if(!test.mobile(form.mobileNo)){
  // 	toast('手机号码不正确','')
  // 	return
  // }
  // if(test.isEmpty(form.address)){
  // 	toast('请输入住址','')
  // 	return
  // }
  // if(!test.mobile(form.birthday)){
  // 	toast('请输入出生日期','')
  // 	return
  // }
  // if(test.isEmpty(form.issueDate)){
  // 	toast('请输入身份证有效期起止日','')
  // 	return
  // }
  // if(!test.mobile(form.expireDate)){
  // 	toast('请输入身份证有效期截止日','')
  // 	return
  // }
  // if(test.isEmpty(form.mobileNo)){
  // 	toast('请输入手机号','')
  // 	return
  // }
  // if(!test.mobile(form.mobileNo)){
  // 	toast('手机号码不正确','')
  // 	return
  // }
  return true;
}
function indexOf(arr, key, val) {
  for (let i = 0; i < arr.length; i++) {
    if (arr[i][key] === val) {
      return i;
    }
  }
  return -1;
}
//通过两个key进行比较 注意类型用的绝对等
function indexOf2(arr, key1, key2, val1, val2) {
  for (let i = 0; i < arr.length; i++) {
    if (arr[i][key1] === val1 && arr[i][key2] === val2) {
      return i;
    }
  }
  return -1;
}
function getRole() {
  let token = uni.getStorageSync("v-token");
  if (!token) return null;
  return uni.getStorageSync(token);
}
function back() {
  uni.navigateBack();
}
//有值的属性才覆盖
function copy(src, desc) {
  if (!src) return;
  Object.assign(
    desc,
    Object.fromEntries(
      Object.entries(src).filter(
        ([key, value]) =>
          value !== null && !(Array.isArray(value) && value.length === 0)
      )
    )
  );
}
function substr(str, endLen) {
  if (str && str.length > endLen) {
    return str.substring(str.length - endLen);
  }
}
function formatDate(timestamp) {
  if (!timestamp) return "";
  let now = new Date(timestamp);
  let year = now.getFullYear(),
    month = now.getMonth() + 1,
    date = now.getDate(),
    hour = now.getHours(),
    minute = now.getMinutes(),
    second = now.getSeconds();
  return (
    year +
    "-" +
    (month < 10 ? "0" + month : month) +
    "-" +
    (date < 10 ? "0" + date : date) +
    " " +
    (hour < 10 ? "0" + hour : hour) +
    ":" +
    (minute < 10 ? "0" + minute : minute) +
    ":" +
    (second < 10 ? "0" + second : second)
  );
}
export default {
  submitForm,
  loginValidate,
  toast,
  checkToken,
  unique,
  baseUrl,
  convertNullToEmpty,
  indexOf2,
  indexOf,
  getRole,
  back,
  copy,
  substr,
  formatDate,
};
